/* eslint-disable no-console */
/*
 * Copyright - 2022 , Schrocken Inc
 * Author: Harish D
 * -----
 * File Description: Wrapper function that runs logic to identify if any material in consumption exceeds allowed limit
 */

import axios from 'axios';
import { appUrl } from '../../../../../../../../utils/config';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../../../../containers/actions/types';



const varianceAlertWrapper =
  ({
    schrockenDeliveryScheduleBatchID,
    targetQuantity,
  }) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: OPEN_BACKDROP,
        backdropText: 'Please wait. checking for consumption...',
      });

      const varianceValidator = (consumptionData) => {
              dispatch({
                type: OPEN_BACKDROP,
                backdropText: 'Validating consumption against standard qty',
              });
        let result = { exceedVariance: false, lotMismatch: false }
              for (let c = 0; c < consumptionData.length; c++) {
      
                if (consumptionData[c]?.quantityVariance > 0 || consumptionData[c]?.quantityVariance < 0) {
                  result = {
                    ...result,
                    exceedVariance: true
                  }
                }
                if (consumptionData[c]?.lotMismatch) {
                  result = {
                    ...result,
                    lotMismatch: true
                  }
                 }

        }
        
        dispatch({
          type: DESTROY_BACKDROP,
        });
        resolve(result);

            };

      axios
        .get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActual/${schrockenDeliveryScheduleBatchID}/${targetQuantity}`)
        .then((res) => {
          if (res.data.status) {
            let bomDetails = res.data?.data && Array.isArray(res.data?.data)
              ? res.data?.data : [];
            varianceValidator(bomDetails)
          }
        })
        .catch((err) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          reject({
            status: false,
            errMessage:
              err.response?.data?.errDescription ||
              'Failed to fetch consumption data',
          });
        });

      // return true;
    });
  };
export default varianceAlertWrapper;
